import { useInternationalStepsContext } from 'pages/settings/pages/compliance/pages/international/context/internationalStepsContext'

export const useLayoutTitle = () => {
  const { getLayoutTitle } = useInternationalStepsContext()

  return getLayoutTitle()
}
